module.exports = __webpack_public_path__ + "media/images/conlance_logo-ff55fcee9bbd55d5d896a5b7c8066432.svg";